import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FollowUpService {
  constructor() {}

  getNumberOfDays = follow_up_date => {
    let targetDate: any = new Date(follow_up_date);

    // Get current date
    let currentDate: any = new Date();

    // Calculate the difference in milliseconds
    let differenceInMs = targetDate - currentDate;

    // Convert milliseconds to days
    let differenceInDays = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));

    return differenceInDays;
  };

  formatDates(inputDate) {
    const date = new Date(inputDate);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  getDueDate = p => {
    let dueDate: any;
    var currentDate = new Date();

    if (p === 'Highest') {
      dueDate = new Date();
    }

    if (p === 'High') {
      currentDate.setDate(currentDate.getDate() + 1);
      dueDate = currentDate.toDateString();
    }

    if (p === 'Medium') {
      currentDate.setDate(currentDate.getDate() + 2);
      dueDate = currentDate.toDateString();
    }

    if (p === 'Low') {
      currentDate.setDate(currentDate.getDate() + 7);
      dueDate = currentDate.toDateString();
    }

    return dueDate;
  };

  getTaskTime = (p, date = null, hours = 2) => {
    let time: any = '8:00am';
    if (p === 'Highest') {
      var currentTime = new Date();

      // Add 2 hours to the current time
      currentTime.setHours(currentTime.getHours() + hours);

      // Round minutes to the nearest multiple of 30
      var minutes = currentTime.getMinutes();
      var roundedMinutes: any = Math.round(minutes / 30) * 30;

      // If the rounded minutes exceed 59, adjust hours and reset minutes
      if (roundedMinutes >= 60) {
        currentTime.setHours(currentTime.getHours() + 1);
        roundedMinutes = 0;
      }

      // Extract hours
      var hours = currentTime.getHours();

      // Determine AM or PM
      var amOrPm = hours >= 12 ? 'pm' : 'am';

      // Convert hours to 12-hour format
      hours = hours % 12;
      hours = hours ? hours : 12; // Handle midnight (0 hours)

      // Add leading zero to minutes if necessary
      roundedMinutes = roundedMinutes < 10 ? '0' + roundedMinutes : roundedMinutes;

      // Concatenate hours, rounded minutes, and AM/PM
      time = hours + ':' + roundedMinutes + amOrPm;
    }

    if (p === 'previous' && date) {
      let d = this.formatDate(date.due_date);
      return d + ', ' + date.task_time;
    }

    return time;
  };

  formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString('en-US', { weekday: 'short', day: 'numeric', month: 'short' });
    return formattedDate.replace(',', ',');
  }

  getNearestTime = (date, hour) => {
    let time: any = '8:00am';
    var currentTime = new Date(date);

    // Add hours to the current time
    currentTime.setHours(currentTime.getHours() + hour);

    // Round minutes to the nearest multiple of 30
    var minutes = currentTime.getMinutes();
    var roundedMinutes: any = Math.round(minutes / 30) * 30;

    // If the rounded minutes exceed 59, adjust hours and reset minutes
    if (roundedMinutes >= 60) {
      currentTime.setHours(currentTime.getHours() + 1);
      roundedMinutes = 0;
    }

    // Extract hours
    var hours = currentTime.getHours();

    // Determine AM or PM
    var amOrPm = hours >= 12 ? 'pm' : 'am';

    // Convert hours to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle midnight (0 hours)

    // Add leading zero to minutes if necessary
    roundedMinutes = roundedMinutes < 10 ? '0' + roundedMinutes : roundedMinutes;

    // Concatenate hours, rounded minutes, and AM/PM
    time = hours + ':' + roundedMinutes + amOrPm;

    return time;
  };
}
